/**
 * Constants for workflow execution performance chart styling.
 * Centralizes colors, dimensions, and transitions for consistency and maintainability.
 */

// Chart colors using semantic tokens
export const CHART_COLORS = {
    completed: {
        stroke: "rgb(var(--surface-success))",
        fill: "rgb(var(--surface-success))",
        fillOpacity: 0.2,
        fillOpacityHover: 0.45, // 0.2 + 0.25
    },
    running: {
        stroke: "rgb(var(--content-brand))",
        fill: "rgb(var(--content-brand))",
        fillOpacity: 0.4,
        fillOpacityHover: 0.65, // 0.4 + 0.25
    },
    pending: {
        stroke: "transparent",
        fill: "rgb(var(--surface-brand))",
        fillOpacity: 0.35,
        fillOpacityHover: 0.6, // 0.35 + 0.25
    },
    failed: {
        stroke: "rgb(var(--surface-destructive))",
        fill: "rgb(var(--surface-destructive))",
        fillOpacity: 0.2,
        fillOpacityHover: 0.45, // 0.2 + 0.25
    },
} as const;

// Active dot configuration
export const ACTIVE_DOT_CONFIG = {
    radius: 6,
    strokeWidth: 2,
    completed: {
        stroke: "rgb(var(--surface-success))",
        fill: "rgb(var(--surface-primary))",
    },
    running: {
        stroke: "rgb(var(--content-brand))",
        fill: "rgb(var(--surface-primary))",
    },
    pending: {
        stroke: "rgb(var(--content-brand))",
        fill: "rgb(var(--surface-primary))",
    },
    failed: {
        stroke: "rgb(var(--surface-destructive))",
        fill: "rgb(var(--surface-primary))",
    },
} as const;

// Cursor line configuration
export const CURSOR_CONFIG = {
    stroke: "rgb(var(--border-base))",
    strokeWidth: 1,
} as const;

// Hover dimming configuration
export const DIMMING_CONFIG = {
    fill: "rgb(var(--surface-primary))",
    activeOpacity: 0,
    dimmedOpacity: 0.5,
    transitionDuration: "300ms",
    transitionTiming: "ease-out",
} as const;

// Chart dimensions
export const CHART_DIMENSIONS = {
    height: 260,
    gapWidth: 0.06, // Gap between steps on x-axis
} as const;
